<template>
  <div>
    <VueRecaptcha
      ref="recaptcha"
      :sitekey="this.sitekey"
      :loadRecaptchaScript="true"
      size="invisible"
      @verify="validate"
    />
    <VueRecaptcha
      ref="pin_recaptcha"
      :sitekey="this.sitekey"
      :loadRecaptchaScript="true"
      size="invisible"
      @verify="pinValidate"
    />
    <VueRecaptcha
      ref="confirm_recaptcha"
      :sitekey="this.sitekey"
      :loadRecaptchaScript="true"
      size="invisible"
      @verify="confirmValidate"
    />
  </div>
</template>
<script>
import VueRecaptcha from "vue-recaptcha";
export default {
  components: { VueRecaptcha },
  data() {
    return {
      cardInfo: {},
      // sitekey: "6LfPfEIfAAAAAIoOQuCwG1GBpeluj1bknkRRbOhs", //#test key
      sitekey: "6Leg2e8UAAAAAJ2aJOXwTYwKlCaQ5MNg3qVBSa8T",
      empty_key: "-111111",
      pinCodeInfo: {},
    };
  },
  methods: {
    resetRecaptcha() {
      this.$refs.recaptcha.reset();
    },

    //send code -------------------------------------------------------------------
    sendPinCode(data) {
      this.pinCodeInfo = data;
      // this.$refs.pin_recaptcha.execute();
      this.pinValidate();
    },
    pinValidate(response) {
      var isTest = 0;
      this.$insProgress.start();
      this.pinCodeInfo = {
        ...this.pinCodeInfo,
        response: response,
        test: isTest,
      };
      this.$bonusApi
        // .post(`cardNomin/createUser/sendCode`, this.pinCodeInfo)
        .post(
          "auth/send/code/phone",
          {
            phoneNumber: this.pinCodeInfo.holderPhone,
            tokenId: this.pinCodeInfo.tokenId,
          },
          {
            headers: {
              "Accept-Language": "en-US",
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
          }
        )
        .then((response) => {
          if (response.data === "Success") {
            this.$emit("sendCodeConfirm", response);
            this.$insProgress.finish();
          } else if (response.data.status === 100) {
            this.$emit("recaptchaError", response.data.message);
            this.$insProgress.finish();
          } else {
            this.$emit("sendCodeConfirm", response);
            this.$insProgress.finish();
          }
          this.resetRecaptcha();
        })
        .catch((error) => {
          this.$emit("recaptchaError", error.response.data.message);
          this.$insProgress.finish();
        });
    },

    //confirm code ------------------------------------------------------------------------------->
    confirmCode(data) {
      this.pinCodeInfo = data;
      this.$refs.confirm_recaptcha.execute();
      this.confirmValidate();
    },
    confirmValidate(response) {
      var isTest = 0;
      this.$insProgress.start();
      this.pinCodeInfo = {
        ...this.pinCodeInfo,
        response: response,
        test: isTest,
      };
      this.$bonusApi
        // .post(`cardNomin/idPhone/checkCode`, this.pinCodeInfo)
        .post(
          "auth/check/code/phone",
          {
            phoneNumber: this.pinCodeInfo.holderPhone,
            tokenId: this.pinCodeInfo.tokenId,
            code: this.pinCodeInfo.secureCode,
          },
          {
            headers: {
              "Accept-Language": "en-US",
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
          }
        )
        .then((response) => {
          if (response.data === "Success") {
            this.$emit("checkConfirm", response);
            this.$insProgress.finish();
          } else if (response.data.status === 100) {
            this.$emit("recaptchaError", response.data.message);
            this.$insProgress.finish();
          } else {
            this.$emit("checkConfirm", response);
            this.$insProgress.finish();
          }
          this.resetRecaptcha();
        })
        .catch((error) => {
          if (error.response.data.statusCode === 400) {
            this.$emit("recaptchaError", error.response.data.message);
            this.$insProgress.finish();
          }
        });
    },

    //save
    checkSubmit(data) {
      this.userInfo = data;
      this.$refs.recaptcha.execute();
      this.validate();
    },
    validate(response) {
      var isTest = 0;
      this.$insProgress.start();
      this.userInfo = { ...this.userInfo, response: response, test: isTest };
      this.$bonusApi
        .post(
          "auth/create/card",
          {
            firstName: this.userInfo.firstName,
            lastName: this.userInfo.lastName,
            registryNumber: this.userInfo.registerNo,
            mail: this.userInfo.email,
            phoneNumber: this.userInfo.holderPhone,
            pinCode: this.userInfo.pinCode,
            systemId: "BonusNomin",
          },
          {
            headers: {
              "Accept-Language": "en-US",
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
          }
        )
        .then((response) => {
          if (response.data === "SUCCESS") {
            this.$emit("checkRecaptcha", response);
            this.$insProgress.finish();
            this.$router.push("login");
            console.log("Success");
          } else if (response.data.status === 100) {
            this.$emit("recaptchaError", response.message);
            this.$insProgress.finish();
          } else {
            this.$emit("checkRecaptcha", response);
            this.$insProgress.finish();
          }
          this.resetRecaptcha();
        })
        .catch((error) => {
          this.$emit("recaptchaError", error.response.data.message);
          this.$insProgress.finish();
        });
    },
  },
};
</script>
